"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalHeader = void 0;
var tslib_1 = require("tslib");
var kebabCase_1 = (0, tslib_1.__importDefault)(require("lodash/kebabCase"));
var React = (0, tslib_1.__importStar)(require("react"));
var test_helpers_1 = require("../../lib/test-helpers");
var box_1 = require("../box");
var flexbox_1 = require("../flexbox");
var icon_button_1 = require("../icon-button");
var padding_1 = require("../padding");
var title_1 = require("../title");
function ModalHeader(props) {
    var onClose = props.onClose, titleText = props.titleText, _a = props.showBorder, showBorder = _a === void 0 ? true : _a, propTestId = props.testId;
    var testId = propTestId !== null && propTestId !== void 0 ? propTestId : (0, test_helpers_1.generateTestId)((0, kebabCase_1.default)(titleText), 'modal-header');
    return (React.createElement(box_1.Box, { borderBottom: showBorder ? 1 : 0, testId: testId },
        React.createElement(padding_1.Padding, { size: 24 },
            React.createElement(flexbox_1.Flexbox, { justifyContent: "space-between" },
                React.createElement(title_1.Title, { size: 17 }, titleText),
                onClose ? (React.createElement(icon_button_1.IconButton, { type: "close", onClick: onClose, testId: (0, test_helpers_1.generateTestId)(testId, 'close-button') })) : null))));
}
exports.ModalHeader = ModalHeader;
//# sourceMappingURL=index.js.map